import {Tooltip} from 'platform/components';
import {HStack, Text, ThemeColorTextPath} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

import {always} from 'ramda';

import {useFps} from '../../../hooks/useFps';
import {getFixedTranslation} from '../../../utils/getFixedTranslation';

export function FpsTracker() {
  const fpsStats = useFps();

  const fpsColor = match<number, ThemeColorTextPath>(fpsStats.currentFps)
    .with(Pattern.number.gte(60), always('success'))
    .with(Pattern.number.gte(30), always('warning'))
    .otherwise(always('danger'));

  const MIN_FPS_DISPLAY = fpsStats.minFps === Infinity ? 0 : fpsStats.minFps;

  return (
    <Tooltip label={getFixedTranslation('page.settings.labels.fpsTracker')}>
      <HStack spacing={1}>
        <Text color={fpsColor}>{fpsStats.currentFps}</Text>
        <Text color="tertiary">FPS</Text>
        <Text color="tertiary">
          (min: {MIN_FPS_DISPLAY}, max: {fpsStats.maxFps})
        </Text>
      </HStack>
    </Tooltip>
  );
}
